// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"Dialog_Dialog__ViBhV"};